
  document.addEventListener("DOMContentLoaded", () => {
    const atcBar = document.querySelector(".sticky-atc-bar");
    const footer = document.querySelector(".footer");

    if (!atcBar || !footer) return;

    // Hide the ATC bar when the footer enters the viewport, show it otherwise
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        atcBar.style.display = entry.isIntersecting ? "none" : "";
      },
      {
        root: null,        // viewport
        threshold: 0,      // trigger as soon as footer touches viewport
      }
    );

    observer.observe(footer);
  });

